import { Component, OnInit } from '@angular/core';
import { UploadProgressService } from '@app/modules/multi-file-uploader/uploadProgress/upload-progress.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  uploadProgressing: boolean;

  constructor(public uploadProgressService: UploadProgressService) { }

  ngOnInit(): void {
  }

}
